module.exports = __webpack_public_path__ + "static/media/Bands2.faee653c.jpg";